import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Container } from 'react-bootstrap';
import "swiper/swiper.min.css";
import "swiper/components/effect-coverflow/effect-coverflow.min.css"
import "swiper/components/pagination/pagination.min.css";
import javascript from '../../../images/javaScript.png';
import reaCT from '../../../images/react.png';
import critical from '../../../images/intro.png';
import './Blogs.css';

import SwiperCore, { EffectCoverflow, Pagination, Autoplay } from 'swiper/core';
import { Link } from 'react-router-dom';

SwiperCore.use([EffectCoverflow, Pagination, Autoplay])

const Blogs = () => {
  return (
    <div className="projects" id="projects">
      <Container>
        <div className="section-title">
          <h2 className="page-title">Blogs</h2>
        </div>
        <Swiper effect={'coverflow'} grabCursor={true} centeredSlides={true} slidesPerView={'auto'} coverflowEffect={{
          "rotate": 50,
          "stretch": 0,
          "depth": 100,
          "modifier": 1,
          "slideShadows": true
        }} loop={true} autoplay={true} pagination={true} className="mySwiper">
          <SwiperSlide>
            <img src={javascript} alt="Project Avatar" />
            <div className="project-card">
              {/* <div className="project-tech">
                <button className="btn react-btn">React</button>
                <button className="btn node-btn">Node</button>
                <button className="btn mongo-btn">MongoDB</button>
                <button className="btn heroku-btn">Heroku</button>
                <button className="btn firebase-btn">Firebase</button>
              </div> */}
              <div className="project-detail">
                <h4>Some JavaScript Interview Questions</h4>
                <p>Could you tell me the differences between null and undefined?   <span><a rel="noreferrer" href="https://tanjin-ahamed123.medium.com/some-javascript-interview-questions-2e77a31a09f8" target="_blank">  read more...</a></span></p>

              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <img src={reaCT} alt="Project Avatar" />
            <div className="project-card">
              <div className="project-detail">
                <h4>Introduction To React</h4>
                <p>React is a javascript library for building UI. It is a declarative, efficient, and <span><a rel="noreferrer" href="https://tanjin-ahamed123.medium.com/introduction-to-react-e2fe0ca8facd" target="_blank"> read more...</a></span></p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <img src={critical} alt="Project Avatar" />
            <div className="project-card">
              <div className="project-detail">
                <h4>Some Critical JavaScript Topics</h4>
                <p>In normal Javascript and earlier requires lots of extra code to simulate <span><a rel="noreferrer" href="https://tanjin-ahamed123.medium.com/some-critical-javascript-topics-79d4e3e5070e" target="_blank"> read more...</a></span></p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <img src={javascript} alt="Project Avatar" />
            <div className="project-card">

              <div className="project-detail">
                <h4>Some important method of Javascript</h4>
                <p>JavaScript is a scripting or programming language that allows you to <span><a rel="noreferrer" href="https://tanjin-ahamed123.medium.com/some-important-method-of-javascript-e1039e1b066e" target="_blank"> read more...</a></span></p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        <div className="d-flex align-items-center justify-content-center">
          <Link to="/allBlog" className="btn text-center moreBtn">More Blog</Link>
        </div>
      </Container>
    </div>
  );
};

export default Blogs;